import { Store } from "@tanstack/react-store";

/**
 * Factory function for creating typed stores
 */
export function createStore<TState>(initialState: TState) {
  return new Store<TState>(initialState);
}

/**
 * Store utilities and types
 */
export type StoreSelector<TState, TSelected> = (state: TState) => TSelected;

export type StoreUpdater<TState> = (state: TState) => TState;
